var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-box"},[_c('h3',[_vm._v("INFORMATION")]),_c('span',[_vm._v(" CheckList App ist eine Anwendung zur Digitalisierung von Wartungsbesuchen in Supermärkten für Heizung, Lüftung und Klima. Wenn Sie noch keine Zugangsdaten haben, registrieren Sie sich bitte. Wir werden uns dann so schnell wie möglich bei Ihnen melden. ")])])
}]

export { render, staticRenderFns }